import React, { useRef, useEffect, useState } from 'react';
import ProTable from '@ant-design/pro-table';
import { Input } from 'antd';
import { pageMerchantIndicatorDetail } from '@/services/chartData';
import { guuid } from '@/utils/utils';

const MerchantPageData = () => {
  useEffect(() => {}, []);

  const [userLabelMode] = useState({
    0: {
      text: '未处理 ',
      status: 0,
    },
    1: {
      text: '普通用户 ',
      status: 1,
    },
    2: {
      text: 'LITTA员工',
      status: 2,
    },
    3: {
      text: '乐刻员工',
      status: 2,
    },
  });
  const columns = [
    {
      title: '商家ID',
      dataIndex: 'tenantId',
      hideInSearch: true,
    },
    {
      title: '商家名称',
      dataIndex: 'tenantName',
      hideInSearch: true,
    },
    {
      title: '关键词',
      dataIndex: 'searchKey',
      hideInTable: true,
      renderFormItem: (_, record) => {
        return (
          <Input
            placeholder="请输入商家名称或手机号"
            style={{ width: '250px' }}
          />
        );
      },
    },
    {
      title: '手机号',
      dataIndex: 'phone',
      hideInSearch: true,
    },
    // {
    //   title: '用户标签',
    //   dataIndex: 'userLabel',
    //   hideInSearch: true,
    //   valueType: 'select',
    //   valueEnum: userLabelMode,
    // },
    {
      title: '会员总数',
      dataIndex: 'memberCount',
      hideInSearch: true,
    },
    {
      title: '月卡会员数',
      dataIndex: 'liteMonthMemberCount',
      hideInSearch: true,
    },
    {
      title: '年卡会员数',
      dataIndex: 'liteAnnualMemberCount',
      hideInSearch: true,
    },
    {
      title: '付费PRO会员数',
      dataIndex: 'aiMemberCount',
      hideInSearch: true,
    },
    {
      title: '包月私教会员数',
      dataIndex: 'customizedMemberCount',
      hideInSearch: true,
    },
    {
      title: '完成首课会员数',
      dataIndex: 'firstClassCompleted',
      hideInSearch: true,
    },
    {
      title: '首课完课率',
      dataIndex: 'firstClassCompletedRatio',
      hideInSearch: true,
    },
    {
      title: '完成次课会员数',
      dataIndex: 'secondClassCompleted',
      hideInSearch: true,
    },
    {
      title: '次课完课率',
      dataIndex: 'secondClassCompletedRatio',
      hideInSearch: true,
    },
    {
      title: '30日总完课数',
      dataIndex: 'classCompletedDays30',
      hideInSearch: true,
    },
    {
      title: '周完课数',
      dataIndex: 'classCompletedDays7',
      hideInSearch: true,
    },
    {
      title: '周均完课数',
      dataIndex: 'classCompletedAverageDays7',
      hideInSearch: true,
    },
  ];

  return (
    <div>
      <ProTable
        columns={columns}
        request={async (params) => {
          const { data, page, code } = await pageMerchantIndicatorDetail({
            requestData: {
              ...params,
              searchKey: params?.searchKey?.trim(),
            },
            page: {
              currentPage: params.current,
              pageSize: params.pageSize,
            },
          });
          if (code !== '00000') {
            return {
              success: false,
            };
          }
          return {
            data: data,
            success: true,
            total: page.count,
          };
        }}
        columnsState={{
          persistenceKey: 'pro-table-singe-demos',
          persistenceType: 'localStorage',
        }}
        scroll={{ x: 'max-content' }}
        rowKey={() => guuid()}
        search={{
          labelWidth: '60',
        }}
        pagination={{
          defaultPageSize: 10,
        }}
        dateFormatter="string"
      />
    </div>
  );
};

export default MerchantPageData;
